import { T } from "@supersig/validate";
const SWRecordPrefixes = [
    "asset",
    "camera",
    "document",
    "paywall",
    "paywall_product",
    "paywall_notification",
    "paywall_survey",
    "instance",
    "page",
    "shape",
    "instance_presence",
    "instance_page_state",
    "pointer",
    "node",
    "state",
    "state_value",
    "style_variable_group",
    "node_property"
];
export const swRecordIdValidator = T.string.refine((id)=>{
    if (!SWRecordPrefixes.some((prefix)=>id.startsWith(`${prefix}:`))) {
        throw new Error(`ID must start with one of: ${SWRecordPrefixes.join(", ")}`);
    }
    return id;
});
